import { FC, ReactNode } from 'react';
import classnames from 'classnames';

import styles from '../shared/PdpSharedDetail/PdpSharedDetail.scss';

type Props = {
    dataTn: string;
    title: ReactNode;
    printHide: boolean | null;
    delimiter?: string | null;
    inlineLabel?: boolean;
    children: ReactNode;
};

export const PdpRespDetail: FC<Props> = ({
    title,
    children,
    dataTn,
    delimiter,
    printHide,
    inlineLabel = false,
}) => {
    const wrapperClasses = classnames(styles.wrapperInline, {
        [styles.printHide]: printHide,
    });
    const titleClasses = classnames(styles.title, { [styles.detailInline]: inlineLabel });
    const contentClasses = classnames(styles.content, {
        [styles.detailBlock]: !delimiter && !inlineLabel,
        [styles.detailInline]: inlineLabel,
    });
    if (title && children) {
        return (
            <li className={wrapperClasses}>
                <div className={titleClasses} data-tn="pdp-spec-title">
                    {title}
                    {inlineLabel && `: `}
                </div>
                <div className={contentClasses} data-tn={`pdp-spec-${dataTn}`}>
                    {children}
                </div>
            </li>
        );
    }
    return null;
};
